import { ArticleSearch, OccArticleSearchParams, ProductArticles } from '@article/const';
import { StateUtils } from '@spartacus/core';
import { ARTICLES_SEARCH, PRODUCT_ARTICLES } from '../article-state';

export const LOAD_ARTICLES_SEARCH = '[Article] ArticlesSearch Load';
export const LOAD_ARTICLES_SEARCH_SUCCESS = '[Article] ArticlesSearch Load Success';
export const LOAD_ARTICLES_SEARCH_FAIL = '[Article] ArticlesSearch Load Fail';

export const LOAD_ARTICLES_BY_PRODUCT_CODE = '[Article] Load Articles By Product Code Load';
export const LOAD_ARTICLES_BY_PRODUCT_CODE_SUCCESS = '[Article] Load Articles By Product Code Load Success';
export const LOAD_ARTICLES_BY_PRODUCT_CODE_FAIL = '[Article] Load Articles By Product Code Load Fail';

export class ArticlesSearchLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_ARTICLES_SEARCH;

  constructor(public payload?: OccArticleSearchParams) {
    super(ARTICLES_SEARCH);
  }
}

export class ArticlesSearchLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_ARTICLES_SEARCH_FAIL;

  constructor(public payload: any) {
    super(ARTICLES_SEARCH, payload);
  }
}

export class ArticlesSearchLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_ARTICLES_SEARCH_SUCCESS;

  constructor(public payload: ArticleSearch) {
    super(ARTICLES_SEARCH);
  }
}

export class ArticlesByProductCodeLoad extends StateUtils.EntityLoadAction {
  readonly type = LOAD_ARTICLES_BY_PRODUCT_CODE;

  constructor(public payload?: string) {
    super(PRODUCT_ARTICLES, payload);
  }
}

export class ArticlesByProductCodeLoadFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_ARTICLES_BY_PRODUCT_CODE_FAIL;

  constructor(
    public code: string,
    public payload: any,
  ) {
    super(PRODUCT_ARTICLES, code, payload);
  }
}

export class ArticlesByProductCodeLoadSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_ARTICLES_BY_PRODUCT_CODE_SUCCESS;

  constructor(
    public code: string,
    public payload: ProductArticles,
  ) {
    super(PRODUCT_ARTICLES, code, payload);
  }
}

// action types
export type ArticlesSearchAction =
  | ArticlesSearchLoad
  | ArticlesSearchLoadSuccess
  | ArticlesSearchLoadFail
  | ArticlesByProductCodeLoad
  | ArticlesByProductCodeLoadSuccess
  | ArticlesByProductCodeLoadFail;
